/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { DevicePreview, SIMPLE_DEVICE_PREVIEWS } from 'cio/components/action-composer/types/push/previewer';

interface DevicePickerArgs {
  items: DevicePreview[];
  selectedValue: string;
  onChange: (value: string) => void;
  onPlatformChange: (platform: string) => void;
}

export default class DevicePicker extends Component<DevicePickerArgs> {
  get selectedPlatform() {
    let selectedItem = this.args.items.find((item) => item.value === this.args.selectedValue);
    return selectedItem ? selectedItem.platform : 'all';
  }

  get hasBothPlatforms() {
    let hasIos = false;
    let hasAndroid = false;
    return this.args.items.some((item) => {
      hasIos = hasIos || item.platform === 'ios';
      hasAndroid = hasAndroid || item.platform === 'android';
      return hasIos && hasAndroid;
    });
  }

  get isDeliveryDetail() {
    return this.args.items === SIMPLE_DEVICE_PREVIEWS;
  }

  get filteredItems() {
    if (this.selectedPlatform === 'all') {
      return this.args.items;
    }
    return this.args.items.filter((item) => item.platform === this.selectedPlatform);
  }

  @action
  onPlatformChange(platform: string) {
    if (platform !== this.selectedPlatform) {
      this.args.onPlatformChange(platform);
    }
  }
}
